package horcrux.frontend.common.extensions

import csstype.PropertiesBuilder
import web.cssom.AutoLengthProperty

var PropertiesBuilder.marginVertical: AutoLengthProperty
    get() = this.marginTop as AutoLengthProperty
    set(value) {
        this.marginTop = value
        this.marginBottom = value
    }

var PropertiesBuilder.marginHorizontal: AutoLengthProperty
    get() = this.marginLeft as AutoLengthProperty
    set(value) {
        this.marginLeft = value
        this.marginRight = value
    }
